"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardTable = void 0;
var react_table_1 = require("react-table");
require("./../../table.css");
var reactstrap_1 = require("reactstrap");
var React = require("react");
var DashboardTable = function (props) {
    var columns = props.columns;
    var data = props.data;
    var _a = react_table_1.useTable({
        columns: columns,
        data: data,
        initialState: { pageIndex: 0 }
    }, react_table_1.useFilters, react_table_1.usePagination), getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, page = _a.page, prepareRow = _a.prepareRow;
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Table, __assign({}, getTableProps, { responsive: true }),
            React.createElement("thead", null, headerGroups.map(function (headerGroup) { return (React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (React.createElement("th", __assign({ scope: "row" }, column.getHeaderProps()), column.render('Header'))); }))); })),
            React.createElement("tbody", __assign({}, getTableBodyProps), page.map(function (row) {
                prepareRow(row);
                return (React.createElement("tr", __assign({}, row.getRowProps()), row.cells.map(function (cell) {
                    return React.createElement("td", __assign({}, cell.getCellProps()), cell.render('Cell'));
                })));
            })))));
};
exports.DashboardTable = DashboardTable;
//# sourceMappingURL=DashboardTable.js.map